import type { SVGProps } from "react";

export default function TeamsIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.875 8.6895C11.875 8.37775 12.1278 8.125 12.4395 8.125H19.4355C19.7473 8.125 20 8.37775 20 8.6895V12.8125C20 15.0562 18.1812 16.875 15.9375 16.875C13.6938 16.875 11.875 15.0562 11.875 12.8125V8.6895Z"
        fill="url(#teams_paint0)"
      />
      <path
        d="M5.625 7.64113C5.625 7.218 5.96801 6.875 6.39113 6.875H14.8589C15.282 6.875 15.625 7.218 15.625 7.64113V13.75C15.625 16.5114 13.3864 18.75 10.625 18.75C7.86356 18.75 5.625 16.5114 5.625 13.75V7.64113Z"
        fill="url(#teams_paint1)"
      />
      <circle cx="16.875" cy="5" r="1.875" fill="#34439E" />
      <circle cx="16.875" cy="5" r="1.875" fill="url(#teams_paint2)" />
      <circle cx="11.25" cy="3.75" r="2.5" fill="url(#teams_paint3)" />
      <mask
        id="teams_mask"
        maskUnits="userSpaceOnUse"
        x="5.625"
        y="0"
        width="10"
        height="18.75"
      >
        <path
          d="M10.625 6.25C12.3509 6.25 13.75 4.85092 13.75 3.125C13.75 1.39908 12.3509 0 10.625 0C8.89906 0 7.5 1.39908 7.5 3.125C7.5 4.85092 8.89906 6.25 10.625 6.25Z"
          fill="white"
        />
        <path
          d="M6.39113 6.875C5.96802 6.875 5.625 7.218 5.625 7.64112V13.75C5.625 16.5114 7.86356 18.75 10.625 18.75C13.3864 18.75 15.625 16.5114 15.625 13.75V7.64112C15.625 7.218 15.282 6.875 14.8589 6.875H6.39113Z"
          fill="white"
        />
      </mask>
      <path
        mask="url(#teams_mask)"
        d="M4.375 7.5C4.375 6.46444 5.21447 5.625 6.25 5.625H10.625C11.6606 5.625 12.5 6.46444 12.5 7.5V15C12.5 16.0356 11.6606 16.875 10.625 16.875H4.375V7.5Z"
        fill="black"
        fillOpacity="0.3"
      />
      <path
        d="M10 4.375H1.25C0.559644 4.375 0 4.93464 0 5.625V14.375C0 15.0654 0.559644 15.625 1.25 15.625H10C10.6904 15.625 11.25 15.0654 11.25 14.375V5.625C11.25 4.93464 10.6904 4.375 10 4.375Z"
        fill="url(#teams_paint4)"
      />
      <path
        d="M8.125 6.875H3.125V8.02169H4.99684V13.125H6.25319V8.02169H8.125V6.875Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="teams_paint0"
          x1="11.875"
          y1="8.5855"
          x2="20.0994"
          y2="13.9597"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#364088" />
          <stop offset="1" stopColor="#6E7EE1" />
        </linearGradient>
        <linearGradient
          id="teams_paint1"
          x1="5.625"
          y1="12.1274"
          x2="15.625"
          y2="12.1274"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#515FC4" />
          <stop offset="1" stopColor="#7084EA" />
        </linearGradient>
        <linearGradient
          id="teams_paint2"
          x1="15"
          y1="3.32237"
          x2="18.6227"
          y2="5.87168"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#364088" />
          <stop offset="1" stopColor="#6E7EE1" />
        </linearGradient>
        <linearGradient
          id="teams_paint3"
          x1="9.46431"
          y1="1.96429"
          x2="12.6786"
          y2="5.71429"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4858AE" />
          <stop offset="1" stopColor="#4E60CE" />
        </linearGradient>
        <linearGradient
          id="teams_paint4"
          x1="0"
          y1="10"
          x2="11.25"
          y2="10"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2A3887" />
          <stop offset="1" stopColor="#4C56B9" />
        </linearGradient>
      </defs>
    </svg>
  );
}
